(function() {
    'use strict';

    angular.module('doclr.berichten', [
            'doclr.praktijk',
            'doclr.components.validations',
            'doclr.components.util',
            'doclr.resources.api',
            'doclr.components.notification',
            'ui.bootstrap',
            'ui.router',
            '$strap.directives'
        ])
        .config(function($stateProvider) {
            $stateProvider
                .state('berichten', {
                    url: '/berichten',
                    abstract : true,
                    template: '<div ui-view></div>'
                })
                .state('berichten.overview', {
                    url: '',
                    views: {
                        '' : {
                            templateUrl : '/partials/components/page.with.sidebar.html',
                            controller: function($scope, userContext, praktijkContext, $state, $uibModal, notificationService, repeater, Berichten) {
                                    $scope.zoekCriteria = {
                                        label: null, // 'inbox', 'opTeVolgen', 'archief'
                                        type: null, // 'conversatie', 'taak'
                                        //user: {type: 'user', id: '/api/users/abc-123'}, {type: 'secretariaat'}
                                        aantal: 10,
                                        zoekString: null
                                    };

                                    function isAddingCommentaar() {
                                        return _.some($scope.berichten, function(bericht) {
                                            return bericht.focussed || bericht.nieuweReactie;
                                        });
                                    }

                                    function clearNewCommentaar() {
                                        _.each($scope.berichten, function(bericht) {
                                            bericht.focussed = false;
                                            bericht.nieuweReactie = null;
                                        });
                                    }

                                    $scope.specGewijzigdHandler = function(spec) {
                                        $scope.zoekCriteria.label = spec.label;
                                        $scope.zoekCriteria.type  = spec.type;
                                        $scope.zoekCriteria.aantal = 10;
                                        clearNewCommentaar();
                                        repeater.restart('berichten');
                                    };



                                    repeater.repeat(function() {
                                        if(!isAddingCommentaar() && $scope.zoekCriteria.label !== null) {
                                            Berichten.zoek(userContext, praktijkContext, $scope.zoekCriteria).then(function(result) {
                                                angular.forEach(result.berichten, function(newBericht) {
                                                    var oldBericht = _($scope.berichten).find(function(oldBericht) {
                                                        return oldBericht.id === newBericht.id;
                                                    });
                                                    if (oldBericht) {
                                                        newBericht.toonAlleReacties = oldBericht.toonAlleReacties;
                                                    }
                                                });
                                                $scope.berichten = result.berichten;
                                                $scope.aantallen = result.overzicht;
                                            });
                                        }
                                    })
                                        .limitTo($scope)
                                        .assignName('berichten')
                                        .setImmediate(true)
                                        .start();

                                    $scope.edit = function(bericht) {
                                        clearNewCommentaar();
                                        $state.go('berichten.overview.detail', {berichtId: bericht.id});
                                    };

                                    $scope.verwijder = function(bericht) {
                                        $scope.confirmmodal  = {
                                            title:  doclrVertaal.instant('partials.berichten.berichten.sidebar.confirmmodalRemoveMessageTitle'),
                                            question : doclrVertaal.instant('partials.berichten.berichten.sidebar.confirmmodalRemoveMessageQuestion')
                                        };

                                        var modalInstance = $uibModal.open({
                                            templateUrl: '/partials/components/confirmmodal.html',
                                            scope : $scope
                                        });

                                        modalInstance.result.then(function() {
                                            Berichten.verwijder(bericht).then(function() {
                                                clearNewCommentaar();
                                                repeater.restart('berichten', 'berichten.aantal.tebekijken');
                                                notificationService.showSuccess(doclrVertaal.instant('partials.berichten.berichten.sidebar.confirmmodalRemoveMessageTitle'));
                                            });
                                        });
                                    };

                                    function ontvangerHeeftTaakUitgevoerd(bericht, ontvanger) {
                                        return bericht.type === 'taak' && _.any(bericht.status.taak, function(taakStatus) {
                                            return taakStatus.done && ontvanger.id === taakStatus.user.id;
                                        });
                                    }

                                    $scope.ontvangerHeeftTaakUitgevoerd = ontvangerHeeftTaakUitgevoerd;

                                    $scope.tooltip = function(bericht, numberOfOntvangersToSkip) {
                                        return _.chain(bericht.ontvangers)
                                            .sortBy($scope.meFirst)
                                            .map(function(ontvanger) {
                                                if(ontvangerHeeftTaakUitgevoerd(bericht, ontvanger)) {
                                                    return '<span class="bericht-ontvangers-ontvanger-heeft-uitgevoerd">' + ontvanger.naam + '</span>';
                                                }
                                                return ontvanger.naam;
                                            })
                                            .value()
                                            .slice(numberOfOntvangersToSkip)
                                            .join('<br>');
                                    };

                                    $scope.fireSearch = function() {
                                        $scope.zoekCriteria.aantal = 10;
                                        clearNewCommentaar();
                                        repeater.restart('berichten');
                                    };

                                    $scope.meerResultaten = function() {
                                        $scope.zoekCriteria.aantal += 10;
                                        clearNewCommentaar();
                                        repeater.restart('berichten');
                                    };

                                    $scope.verwijderCommentaar = function(commentaar) {
                                        $scope.confirmmodal  = {
                                            title:  doclrVertaal.instant('partials.berichten.berichten.sidebar.confirmmodalRemoveCommentTitle'),
                                            question : doclrVertaal.instant('partials.berichten.berichten.sidebar.confirmmodalRemoveCommentQuestion')
                                        };

                                        var modalInstance = $uibModal.open({
                                            templateUrl: '/partials/components/confirmmodal.html',
                                            scope : $scope
                                        });

                                        modalInstance.result.then(function() {
                                            Berichten.verwijderCommentaar(commentaar).then(function() {
                                                clearNewCommentaar();
                                                repeater.restart('berichten');
                                                notificationService.showSuccess(doclrVertaal.instant('partials.berichten.berichten.sidebar.showSuccesCommentRemoved'));
                                            });
                                        });
                                    };

                                    $scope.reageer = function(bericht) {
                                        Berichten.addCommentaar(bericht, bericht.nieuweReactie).then(function() {
                                            clearNewCommentaar();
                                            repeater.restart('berichten');
                                        });
                                    };

                                    $scope.verwijderHuidigLabel = function(bericht) {
                                        bericht.verwijderLabel($scope.zoekCriteria.label).then(function() {
                                            if(bericht.type === 'taak'){
                                                if ($scope.zoekCriteria.label === 'archief') {
                                                    notificationService.showSuccess(doclrVertaal.instant('partials.berichten.berichten.sidebar.messageTaskMovedToInbox'));
                                                } else if ($scope.zoekCriteria.label === 'inbox') {
                                                    notificationService.showSuccess(doclrVertaal.instant('partials.berichten.berichten.sidebar.messageTaskMovedToArchive'));
                                                } else if ($scope.zoekCriteria.label === 'opTeVolgen') {
                                                    notificationService.showSuccess(doclrVertaal.instant('partials.berichten.berichten.sidebar.messageTaskNotFollowed'));
                                                }

                                            }else{
                                                if ($scope.zoekCriteria.label === 'archief') {
                                                    notificationService.showSuccess(doclrVertaal.instant('partials.berichten.berichten.sidebar.messageMovedToInbox'));
                                                } else if ($scope.zoekCriteria.label === 'inbox') {
                                                    notificationService.showSuccess(doclrVertaal.instant('partials.berichten.berichten.sidebar.messageMovedToArchive'));
                                                } else if ($scope.zoekCriteria.label === 'opTeVolgen') {
                                                    notificationService.showSuccess(doclrVertaal.instant('partials.berichten.berichten.sidebar.messageNotFollowed'));
                                                }
                                            }
                                            repeater.restart('berichten', 'berichten.aantal.tebekijken');
                                        });
                                    };

                                    $scope.markeerHuidigeTaakTooltipText = function(bericht){
                                        return bericht.afgewerkt
                                            ? doclrVertaal.instant('partials.berichten.berichten.overzicht.labelMarkTaskToExecute')
                                            :doclrVertaal.instant('partials.berichten.berichten.overzicht.labelMarkTaskExecuted');
                                    }

                                    $scope.verwijderHuidigLabelTooltipText = function() {
                                        if ($scope.zoekCriteria.label === 'archief') {
                                            return doclrVertaal.instant('partials.berichten.berichten.sidebar.tooltipMoveToInbox');
                                        } else if ($scope.zoekCriteria.label === 'opTeVolgen') {
                                            return doclrVertaal.instant('partials.berichten.berichten.sidebar.tooltipDontFollow');
                                        } else {
                                            return doclrVertaal.instant('partials.berichten.berichten.sidebar.tooltipMoveToArchive');
                                        }
                                    };

                                    $scope.toggleAfgewerkt = function(bericht) {
                                        bericht.toggleAfgewerkt().then(function() {
                                            if(bericht.afgewerkt && $scope.zoekCriteria.label !== 'inbox') {
                                                notificationService.showSuccess(doclrVertaal.instant('partials.berichten.berichten.sidebar.messageMovedToInbox'));
                                            } else if(!bericht.afgewerkt) {
                                                notificationService.showSuccess(doclrVertaal.instant('partials.berichten.berichten.sidebar.messageMovedToArchive'));
                                            }
                                            repeater.restart('berichten', 'berichten.aantal.tebekijken');
                                        });
                                    };
                                }
                        },
                        'content@berichten.overview': {
                            templateUrl: '/partials/berichten/berichten.overzicht.html'
                        },
                        'sidebar@berichten.overview' : {
                            templateUrl: '/partials/berichten/berichten.sidebar.html',
                            controller : function($scope, $state) {
                                $scope.createNew = function() {
                                    $state.go('berichten.overview.detail');
                                };
                            }
                        }
                    }
                })
                .state('berichten.overview.detail', {
                    url: '/detail?berichtId',
                    views: {
                        '@': {
                            resolve: {
                                users: function(Users, praktijkContext) {
                                    return Users.getList(praktijkContext.id);
                                },
                                bericht : function(Berichten, $stateParams, userContext) {
                                    return $stateParams.berichtId ? Berichten.getBericht(userContext, decodeURIComponent($stateParams.berichtId)) : {nieuw: true, type: 'taak'};
                                }
                            },
                            templateUrl: '/partials/berichten/berichten.detail.html',
                            controller: function($scope, Berichten, repeater, users, praktijkContext, userContext, $state, bericht, notificationService) {
                                    users.push({
                                        isgroep: true,
                                        groep: 'secretariaat',
                                        naam: 'Secretariaat'
                                    });
                                    $scope.userContext = userContext;
                                    $scope.users = users;
                                    $scope.bericht = bericht;
                                    $scope.selectedUsers = bericht.nieuw ? [] : bericht.ontvangers;
                                    $scope.opgevolgdDoor = userContext.isSecretariaat() ? 'secretariaat' : 'mij';
                                    $scope.bewaar = function() {
                                        if(bericht.nieuw) {
                                            var promise = Berichten.maakNieuwBericht(userContext, {
                                                opgevolgdDoorSecretariaat: $scope.opgevolgdDoor === 'secretariaat',
                                                bericht : bericht.bericht,
                                                type : bericht.type,
                                                ontvangers : $scope.selectedUsers
                                            });

                                            promise.then(function() {
                                                if(bericht.type === 'taak') {
                                                    notificationService.showSuccess(doclrVertaal.instant('partials.berichten.berichten.sidebar.messageTaskMade'));
                                                } else {
                                                    notificationService.showSuccess(doclrVertaal.instant('partials.berichten.berichten.sidebar.messageMessageMade'));
                                                }
                                                repeater.restart('berichten.aantal.tebekijken');
                                                $state.go('^');
                                            });
                                        } else {
                                            bericht.ontvangers = $scope.selectedUsers;
                                            bericht.save().then(function() {
                                                if(bericht.type === 'taak') {
                                                    notificationService.showSuccess(doclrVertaal.instant('partials.berichten.berichten.sidebar.messageTaskChanged'));
                                                } else {
                                                    notificationService.showSuccess(doclrVertaal.instant('partials.berichten.berichten.sidebar.messageMessageChanged'));
                                                }
                                                repeater.restart('berichten.aantal.tebekijken');
                                                $state.go('^');
                                            });
                                        }
                                    };

                                    $scope.terugNaAnnuleren = function() {
                                        $state.go('^');
                                    };

                                    $scope.naam = function(user) {
                                        return user.naam;
                                    };
                                }
                        }
                    }
                });
        })
        .controller('openstaandeBerichtenController', function($scope, repeater, Berichten, userContext, praktijkContext) {
           if(!praktijkContext.vgDisabledFeature) {
               repeater.repeat(function () {
                       Berichten.getAantalTeBekijkenBerichten(userContext).then(function (aantal) {
                           $scope.aantalTeBekijkenBerichten = aantal;
                       });
                   }
               )
                   .limitTo($scope)
                   .assignName('berichten.aantal.tebekijken')
                   .setImmediate(true)
                   .start();
           }
        })
        .directive('selectOntvangers', function() {
            return {
                restrict: 'A',
                scope: {
                    ontvangers: '=',
                    selectedOntvangers: '=',
                    displayFunction: '&'
                },
                templateUrl: '/partials/components/select.ontvangers.html',
                link: function($scope) {

                    function getOntvangersInGroep(groep) {
                        return _.filter($scope.ontvangers, function(ontvanger) { return !ontvanger.isgroep && ontvanger.groep === groep; });
                    }

                    function getSelectedOntvangersWithoutOntvangersInGroep(groep) {
                        var ontvangersInGroep = getOntvangersInGroep(groep);
                        return _.reject($scope.selectedOntvangers, function(selectedOntvanger) {
                            return _.contains(ontvangersInGroep, selectedOntvanger);
                        });
                    }

                    function selectOntvanger(ontvanger) {
                        if(ontvanger.isgroep) {
                            $scope.selectedOntvangers.push(ontvanger);
                            $scope.selectedOntvangers = getSelectedOntvangersWithoutOntvangersInGroep(ontvanger.groep);
                        } else {
                            if(!$scope.isInSelectedGroep(ontvanger)) {
                                $scope.selectedOntvangers.push(ontvanger);
                            }
                        }
                    }

                    function deSelectOntvanger(ontvanger) {
                        $scope.selectedOntvangers.splice($scope.selectedOntvangers.indexOf(ontvanger), 1);
                        if(ontvanger.isgroep) {
                            $scope.selectedOntvangers = getSelectedOntvangersWithoutOntvangersInGroep(ontvanger.groep);
                        }
                    }

                    function getSelectedGroepen() {
                        return _.chain($scope.selectedOntvangers).where({ isgroep : true }).pluck('groep').value();
                    }

                    $scope.isSelected = function(ontvanger) {
                        return _.contains(_.pluck($scope.selectedOntvangers, 'id'), ontvanger.id);
                    };

                    $scope.isInSelectedGroep = function(ontvanger) {
                        return !ontvanger.isgroep && _.contains(getSelectedGroepen(), ontvanger.groep);
                    };

                    $scope.toggleSelection = function(ontvanger) {
                        if($scope.isSelected(ontvanger)) {
                            deSelectOntvanger(ontvanger);
                        } else {
                            selectOntvanger(ontvanger);
                        }
                    };

                    $scope.selectAll = function() {
                        $scope.deselectAll();
                        _.chain($scope.ontvangers).filter(function(ontvanger) { return !ontvanger.isgroep; }).each(selectOntvanger);
                    };

                    $scope.deselectAll = function() {
                        _.each($scope.ontvangers, deSelectOntvanger);
                    };

                }
            };
        })
        .directive('berichtNavigator', function() {
            return {
                templateUrl: '/partials/berichten/bericht.navigator.html',
                scope: {
                    aantallen: '=',
                    specGewijzigdHandler: '&'
                },
                controller: function($scope) {
                    $scope.specs = [
                        {id: 'inbox',      label: 'inbox',      guiLabel: doclrVertaal.instant('partials.berichten.berichten.sidebar.labelBadgeInbox'), benadrukAantalGroterDanNul: true, subSpecs: [
                            {id: 'inboxBerichten', label: 'inbox', type: 'conversatie', guiLabel: doclrVertaal.instant('partials.berichten.berichten.sidebar.labelBadgeMessages'), benadrukAantalGroterDanNul: true},
                            {id: 'inboxTaken',     label: 'inbox', type: 'taak',        guiLabel: doclrVertaal.instant('partials.berichten.berichten.sidebar.labelBadgeTasks')    , benadrukAantalGroterDanNul: true}
                        ]},
                        {id: 'opTeVolgen', label: 'opTeVolgen', guiLabel: doclrVertaal.instant('partials.berichten.berichten.sidebar.labelBadgeTasksMadeByMe')},
                        {id: 'archief',    label: 'archief',    guiLabel: doclrVertaal.instant('partials.berichten.berichten.sidebar.labelBadgeArchive')}
                    ];

                    $scope.getAantal = function(spec) {
                        if ($scope.aantallen === undefined) {
                            return undefined;
                        }

                        return $scope.aantallen[spec.id];
                    };

                    $scope.hasAantal = function(spec) {
                        return $scope.getAantal(spec) !== undefined;
                    };

                    $scope.kiesSpec = function(spec) {
                        $scope.selectedSpec = spec;
                        $scope.specGewijzigdHandler({spec: spec});
                    };

                    $scope.kiesSpec($scope.specs[0]);
                }
            };
        });
})();